import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/billing/lib/CollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
